var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,{"list":_vm.list}),_vm._v(" "),(_vm.total > 0 && (_vm.total > _vm.size || _vm.alwaysShowPager))?_c('el-pagination',{staticClass:"pager",attrs:{"background":"","layout":_vm.layout,"total":_vm.total,"page-size":_vm.size,"page-sizes":_vm.pageSizes},on:{"current-change":_vm.changePage,"size-change":_vm.changeSize}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24a43242","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/List.vue
// module id = null
// module chunks = 